import React from 'react';
import * as MD from '@material-ui/core';

import "../../react-table.css";
import { IApplicationState } from '../../Store';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Row, useTable } from 'react-table';
import { useSticky } from "react-table-sticky";
//ICONS
import RecordVoiceOverOutlinedIcon from '@material-ui/icons/RecordVoiceOverOutlined';
import PeopleOutlineOutlinedIcon from '@material-ui/icons/PeopleOutlineOutlined';
import AccessTimeOutlinedIcon from '@material-ui/icons/AccessTimeOutlined';
import { ElectionType, IElectionsState } from '../../Store/Elections/Types';

const Styles = styled.div`
  padding: 1rem;

  table {
    border-spacing: 0;
    border: 1px solid black;
    width: -webkit-fill-available;
    overflow: auto;
    display: block;
    max-width: fit-content;
    height: fit-content;
    background: dark-gray;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
      }
    }
  }
`;


function tdStyle(resizeTable:boolean, row:any, cell:any, theme:any, tableType?:ElectionType) {
  let style:any = {
    padding: '5px',
    fontWeight: 500,
    display: 'table-cell',
    textAlign: 'center',
    minWidth: 168,
    width: 168,
    maxWidth: 400,
    fontSize: 10,
    background: '#EEEEEE',
    color: 'black'
  }
  if (resizeTable) {
    style = {
      ...style,
      minWidth: 65,
      width: 65,
      maxWidth: 65,
    }
  } 
  if (tableType && tableType === ElectionType.NATIONAL) {
    style = {
      ...style,
      minWidth: 110,
      width: 110,
      maxWidth: 110,
    }
  }
  if (row.original["Libelle"] === 'Total' || row.original['Libelle'] === 'Totaux') {
    style={
      ...style,
      fontWeight: 'bold'
    }
  }
  if (cell.column.Header === '' || cell.column.parent === undefined) {
    style={
      ...style,
      background: theme.palette.primary.main
    }
  }
  if (cell.column.parent && cell.column.parent.id.indexOf('total') > -1) {
    style={
      ...style,
      background: "lightgray",
      fontWeight: "bold"
    }
  }
  if ((cell.column.Header=== 'Durée' || cell.column.Header === 'Percent')  && cell.column.id !== 'duree_total' && cell.column.id !== '%_total' ) {
    style={
      ...style,
      background: "lightgray",
      fontWeight: "bold"
    }
  }
  if (cell.value !== '--') {
    style = {
      ...style,
      cursor: 'pointer'
    }
  }
  return style
}

function setThStyle(column:any, index:number, props:any) {
    let color:string = 'white'
    let backgroundColor:string = props.theme.palette.secondary.main
    
    let width = 60
    let minWidth = 60
    let maxWidth = 90
    let fontSize = 11
    let style:any = {
      backgroundColor: backgroundColor,
      color: color,
      width: width,
      minWidth: minWidth,
      maxWidth: maxWidth,
      fontSize: fontSize
    }
    if (props.showLogo && typeof(column.Header) !== 'string') {
        style={
          ...style,
          borderBottom: 'hidden',
          backgroundColor: 'white'
        }
    }
    
    if (typeof(column.cid) === 'string'  && column.cid.indexOf("restyle") > -1) {
      style={
        ...style,
        paddingBottom: '27px',
        paddingTop: '0px'
      }
    }
    if ((column.parent && column.parent.id.toLowerCase().indexOf('total') > -1) || (column.id && column.id.toLowerCase().indexOf('total') > -1)) {
      style= {
        ...style,
        backgroundColor: 'rgb(66, 71, 94)',
      }
    }
    if ((column.Header === "Durée" || column.Header === 'Percent') && column.id !== 'duree_total' && column.id !== '%_total') {
      style= {
        ...style,
        backgroundColor: 'rgb(66, 71, 94)',
      }
    }
    if (typeof(column.id) === 'string' && column.id.indexOf("Libelle") > -1) {
      style= {
        ...style,
        width: 200,
        minWidth: 200,
        maxWidth: 200
      }
    }
    if (column.id.indexOf('none') > -1) {
        style={
          ...style,
          borderBottom: 'hidden',
        }
    }
    if (props.elections.tableType === ElectionType.CIRCONSCRIPTION && column.parent && column.parent.id.indexOf('total_none') > -1) {
      style={
        ...style,
        borderBottom: '1px solid black',
        //paddingBottom: '27px',
        //paddingTop: '0px',
        marginTop: '-23px',
        position: 'absolute',
        width: "129px",
        minWidth: "60px",
        maxWidth: "140px",
        fontSize: "11px",
        padding: "0px 16px 7px 16px"
      }
    }
    if (props.elections.tableType === ElectionType.NATIONAL && column.parent && column.parent.id.indexOf('total_none') > -1) {
      style={
        ...style,
        borderBottom: '1px solid black',
        marginTop: '-14px',
        width: "220px",
        minWidth: "60px",
        maxWidth: "220px",
        fontSize: "11px",
        padding: "0px 16px 25px"
      }
    }
    return style
}

function prepareHeaders(column:any) {
  let header:any = column.render('Header')
  switch (column.Header) {
    case 'Candidats': 
      header = <MD.Tooltip title={'Candidats'}>
                  <RecordVoiceOverOutlinedIcon/> 
              </MD.Tooltip>
      break;
    case 'Soutiens':
      header = <MD.Tooltip title={'Soutiens'}>
                  <PeopleOutlineOutlinedIcon/> 
              </MD.Tooltip>
      break;
    case 'Durée':
      header = <MD.Tooltip title={'Durée'}>
                  <AccessTimeOutlinedIcon/> 
              </MD.Tooltip>
      break;
      case 'Percent':
        header = <MD.Tooltip title={'Pourcentage'}>
                    <span style={{fontWeight: 600, fontSize: "17px"}}> % </span> 
                </MD.Tooltip>
        break;
  }
  return header
}
function Table(props:IOwnProps & IPropsFromState & MD.WithTheme) {
  let columns:any = props.columns;
  let data:any = props.data;
  const {
    getTableProps, 
    getTableBodyProps, 
    headerGroups, 
    rows, 
    prepareRow,
  } = 
  useTable({
    columns, 
    data,
  },
  useSticky
  )

  // Render Data Table UI
  return (
    <table {...getTableProps()} style={{maxHeight: props.maxHeight}}>
      <thead>
        {headerGroups.map(headerGroup => {
          return (
            <tr {...headerGroup.getHeaderGroupProps()} >
              {headerGroup
                .headers
                .map((column:any, index:number) => {
                  let any = setThStyle(column, index, props)
                  return (
                  <th {...column.getHeaderProps()}
                  style={{
                    ...any,
                    fontWeight: 500,
                    //fontSize: '13px',
                    //display: 'table-cell',
                    wordBreak: 'break-word',
                    textAlign: 'center'
                  }}
                  >
                    {prepareHeaders(column)}
                  </th>
                )})
              }
            </tr>
          )}
        )}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((r:Row, i) => {
          let row:Row | null = r 
          if (row !== null) {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}
              >
                {row
                  .cells
                  .map((cell, index) => {
                    return <td {...cell.getCellProps()} 
                    onClick={() => props.rowClick(null, row, cell.column) }
                    style={tdStyle(props.resizeTable, row, cell, props.theme, props.tableType)}
                    >{cell.render('Cell')}</td>
                  })}
              </tr>
            )
          } else return null
        })}
      </tbody>
      <tfoot>
        {/* {rows.map((r:Row, i) => {  
          let row:Row | null = r //prepareFooters(r)
          if (row !== null) {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}
              style={{
                borderTop: '1px solid black'
              }}
              >
                {row
                  .cells
                  .map((cell, index) => {
                    return <td {...cell.getCellProps()} 
                    style={{
                      ...tdStyle(props.resizeTable),
                      borderTop: '1px solid black',
                      borderBottom: '0px solid black'
                    }}
                    >{cell.render('Cell')}</td>
                  })}
              </tr>
            )
          } else return null
        })} */}
      </tfoot>
    </table>
  )
}

const styles = (theme:any) => MD.createStyles({
    root: {
      width: '100%',
    },
    paper: {
      width: '100%',
      clear:'both',
      marginBottom: theme.spacing(2),
    },
    table: {
      minWidth: 750,
    },
    toggleDiv:{
      width:'100%',
    }
  });

interface IPropsFromState {
  elections: IElectionsState
}
  
interface IPropsFromDispatch {
}
  
interface IOwnProps {
    resizeTable: boolean,
    data: any[],
    columns:any[],
    rowClick: (state: any, rowInfo: any | undefined, column: any) => void;
    showLogo: boolean;
    maxHeight?: number;
    tableType?: ElectionType; 
}

type AllProps =
    MD.WithTheme &
    MD.WithStyles<typeof styles> &
    IPropsFromState &
    IPropsFromDispatch &
    IOwnProps;

interface IOwnState {
  columns: any[],
  maxHeight: number
}

export class ElectionTableDashboardComponent extends React.Component<AllProps, IOwnState> {
    
    public constructor(props: AllProps) {
        super(props);
        this.state = {
          columns: [],
          maxHeight: window.innerHeight
        }
    }

    componentDidMount() {
      this.setState({maxHeight: window.innerHeight - 135})
    }

    componentDidUpdate(prevProps: AllProps) {
    
    }
    
    getTrProps = (state:any, rowInfo:any, instance:any) => {
      if (rowInfo) {
        return {
          style: {
            height: '25px'
          }
        }
      }
      return {};
    }
    render() {
        return (
          <Styles>
            <Table
              {...this.props}
              theme={this.props.theme}
              resizeTable={this.props.resizeTable}
              rowClick={this.props.rowClick.bind(this)}
              data={this.props.data} 
              columns={this.props.columns} 
              elections={this.props.elections}
              maxHeight={this.state.maxHeight}
              tableType={this.props.elections.tableType}
            />
          </Styles>           
        )
    }
}
const mapStateToProps = ({ i18n, elections }: IApplicationState) => ({
  i18n: i18n.i18n,
  elections
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
});

export const ElectionTableDashboard = connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })
                (MD.withTheme(MD.withStyles(styles)(ElectionTableDashboardComponent)));